<template>
  <div class="card-pagamento-carta">
      <!-- <div class="titulo-fluxos"> PAGAMENTO</div>
      <div class="subtitulo-fluxos"> Selecione a forma de pagamento e o tipo de carta </div> -->
      <g-titulo-steps
      titulo="PAGAMENTO"
      subtitulo="Selecione a forma de pagamento e o tipo de carta"
      :imagemEmpresa = imagemEmpresa
      />

      <div class="cartaproposta-pagamento-conteudo espacamento-fluxos">
        <div class="forma-pagamento">
          <div class="titulo-conteudo-fluxos"> Forma de Pagamento <strong class="asterisco-obrigatorio">*</strong></div>
          <div><PDropDown
            :filter=true
            class= "forma-pagamento-dropdown"
            :options="formaDePagamentoArray"
             optionLabel="formaDePagamento"
             optionValue="id"
             v-model="formaDePagamentoSelecionado"
             @change="porcentagem(formaDePagamentoSelecionado)"
              :disabled="this.TemSolicitacaoAutorizada == 1"
            ></PDropDown></div>
        </div>

        <div class="imposto">
          <div class="titulo-conteudo-fluxos"> Porcentagem Financeira </div>
          <PInputText disabled class="imposto-inputtext" v-model="this.porcentagemFinal" :options="formaDePagamentoArray " ></PInputText>
        </div>

        <div class="tipo-carta">
          <div class="titulo-conteudo-fluxos"> Tipo de Carta  <strong class="asterisco-obrigatorio">*</strong></div>
          <div><PDropDown
             class="tipo-carta-dropdown"
             :options="cartaArray"
              optionLabel="text"
              optionValue="enum"
              v-model="cartaSelecionada"
            ></PDropDown></div>

          </div>
        </div>
        <div class="buttons-next-back">
          <div class="button-next">
            <g-button
            tipo="amarelo"
            altura="35px"
            largura="100%"
            negritoTexto 
            @click="step3()"
            > CONTINUAR </g-button>
          </div>
          <div class="button-back">
            <g-button
            tipo="cinza" 
            altura="35px"
            largura="100%"
            negritoTexto 
            @click="VoltarStep1()"
            :class="`button-voltar-carta ${(this.AutorizaPrazoBool) ? 'invisivel' : ''}`"
            > VOLTAR </g-button>
          </div>
        </div>
  </div>
</template>

<script>
import GerarCartaPropostaPagamento from './GerarCartaPropostaPagamento.js'
export default GerarCartaPropostaPagamento
</script>

<style scoped>
.invisivel{
    visibility: hidden;
}
.pagamento-titulo {
  color: #4F2C19;
  text-align: center;
  font-family: Montserrat;
  font-weight: 600;
  opacity: 1;
}

.pagamento-subtitulo {
  color: #8A8A8A;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;
  opacity: 1;
}

.titulo {
  color: #707070;
  text-align: left;
  font-family: Montserrat;
  font-weight: 600;
  opacity: 1;
  margin: 10px 0;
}

.imposto-inputtext {
  color: rgb(0, 0, 0);
  text-align: left;
  font-family: Montserrat;
  font-weight: 500;
}

.imposto .imposto-inputtext {
  background-color: #eceaea;
  border: none;
}

.forma-pagamento-dropdown, .imposto-inputtext, .tipo-carta-dropdown {
  width: 100%;
  text-align: left;
  border-radius: 5px;
}

.forma-pagamento-dropdown, .tipo-carta-dropdown {
  border: 1px solid #ced4da;
}



@media (min-width:310px) {
.cartaproposta-pagamento {
  height: 100%;
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: 20% repeat(2, auto);
  padding: 2rem 0.5rem 1.5rem 0.5rem;
}
.cartaproposta-pagamento-titulo { grid-area: 1 / 1 / 2 / 2; align-self: center; }
.cartaproposta-pagamento-conteudo { grid-area: 2 / 1 / 3 / 2; align-self: flex-start; }
.container-botoes { grid-area: 3 / 1 / 4 / 2; align-self: flex-end; }

.pagamento-titulo {
  font-size: 18px;
}
.pagamento-subtitulo {
  font-size: 15px;
}
.titulo {
  font-size: 13px;
}

.imposto {
  margin: 20px 0 25px 0;
}

.container-botoes {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: repeat(2, auto);
  grid-row-gap: 15%;
  margin-top: 60px;
}
.button-continuar { grid-area: 1 / 1 / 2 / 2; width: 100%; }
.button-voltar { grid-area: 2 / 1 / 3 / 2; width: 100%; }
}


@media (min-width:368px) {
.cartaproposta-pagamento {
  padding: 2rem 1rem 1.5rem 1rem;
}
}


@media (min-width:600px) {
.cartaproposta-pagamento {
  padding: 2rem 5rem 1.5rem 5rem;
}

.container-botoes {
  margin-top: 70px;
}
}


@media (min-width:801px) {
.cartaproposta-pagamento {
  grid-template-rows: 24% repeat(2, auto);
  padding: 2rem 8rem 1.5rem 8rem;
}

.cartaproposta-pagamento-conteudo {
  display: grid;
  grid-template-columns: repeat(2, 48%);
  grid-template-rows: repeat(2, auto);
  grid-column-gap: 4%;
  grid-row-gap: 5%;
  margin-top: 10px
}
.forma-pagamento { grid-area: 1 / 1 / 2 / 2; align-self: flex-start; }
.imposto { grid-area: 1 / 2 / 2 / 3; align-self: flex-end; margin: 0; }
.tipo-carta { grid-area: 2 / 1 / 3 / 3; align-self: flex-start; }

.container-botoes {
  margin-top: 90px;
}
}


@media (min-width:1025px) {
.cartaproposta-pagamento {
  grid-template-rows: 26% repeat(2, auto);
  padding: 2rem 14rem 1.5rem 14rem;
}

.pagamento-titulo {
  font-size: 20px;
}
.titulo {
  font-size: 14px;
}

.container-botoes {
  width: 100%;
   display: flex;
   flex-direction: row-reverse;
   align-items: baseline;
   gap: 15px;
}
.button-voltar { grid-area: 1 / 1 / 2 / 2; width: 70%; justify-self: flex-end; }
.button-continuar { grid-area: 1 / 2 / 2 / 3; width: 70%; justify-self: flex-start; }
}


@media (min-width:1281px) {
.cartaproposta-pagamento {
  padding: 2rem 20rem 1.5rem 20rem;
}
}


@media (min-width:1500px) {
.cartaproposta-pagamento {
  padding: 2rem 26rem 1.5rem 26rem;
}
}
</style>
